jQuery(document).ready(function($) {
  $( '#wco-mobile-menu-2-dl-menu' ).dlmenu({
    animationClasses : { classin : 'dl-animate-in-2', classout : 'dl-animate-out-2' },
    onLevelClick : function( el, name ) { return true; },
    onLinkClick : function( el, ev ) { return true; },
    backLabel : 'zurück'
  });

  var controller = new slidebars();
  controller.init();
  $( '.wco-mobile-menu-2-toggler' ).on( 'click', function ( event ) {
    event.stopPropagation();
    controller.toggle( 'wco-mobile-menu-2' );
  } );

  // Close any
  $( controller.events ).on( 'opened', function () {
    $( '[data-canvas="container"]' ).addClass( 'js-close-any-slidebar' );
  } );

  $( controller.events ).on( 'closed', function () {
    $( '[data-canvas="container"]' ).removeClass( 'js-close-any-slidebar' );
  } );

  $( 'body' ).on( 'click', '.js-close-any-slidebar', function ( event ) {
    event.stopPropagation();
    controller.close();
  } );
});
